import { render, staticRenderFns } from "./PcodeText.vue?vue&type=template&id=65ffd20a&"
import script from "./PcodeText.vue?vue&type=script&lang=js&"
export * from "./PcodeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports